import { useCallback } from 'react';
import { DurationFormatter } from '../../../../../../components/SearchForm/components/TravelPeriodField/utils.js';
export function useInputValues(selectedInput, isActivated) {
  return useCallback((inputType, nextValue) => {
    return selectedInput === inputType && nextValue >= 0 && isActivated ? DurationFormatter.format(nextValue) : '';
  }, [selectedInput, isActivated]);
}